import * as React from 'react';
import PropTypes from 'prop-types';
import { getUserAgreement } from '../action/login';
import { UserAgreementStates } from '../typing';

require('./component.scss');

/**
 * 用户协议展示
 * 
 * @author Jiawei Chen
 * @since 18/5/2022
 */
class UserAgrement extends React.PureComponent<any, UserAgreementStates> {
  constructor(props) {
    super(props);
    this.state = {
      userAgreementHtml: '',
    };
  }

  componentDidMount(): void {
    getUserAgreement().then(d => this.setState({
      userAgreementHtml: d,
    }));
  }

  render() {
    const {userAgreementHtml} = this.state;
    return (
      userAgreementHtml? 
        <div dangerouslySetInnerHTML={{__html: userAgreementHtml}} /> : <></>
    );
  }
}

(UserAgrement as React.ComponentType).defaultProps = {
  loading: true,
  location: { pathname: '' },
};

(UserAgrement as React.ComponentType<any>).contextTypes = {
  numeric: PropTypes.object,
  intl: PropTypes.object,
};

export default UserAgrement;
